import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps } from '@pcmp/react-providers';
import FindUserSider, { FindUserData } from '../find-user';

export interface AddCoworkerSiderProps extends ModalComponentBaseProps {
  onConfirm: (email: string) => void | Promise<void>;
}

const AddCoworkerSider: FC<AddCoworkerSiderProps> = ({
  onConfirm,
  ...rest
}) => {
  // Hooks
  const { t } = useTranslation();
  // Event handlers
  const handleConfirm = useCallback(
    async (selectedUser: FindUserData) => {
      if (!selectedUser) return;

      await onConfirm(selectedUser.email);
    },
    [onConfirm]
  );

  return (
    <FindUserSider
      {...rest}
      descriptionText={t('page.admin.users.addUserDescription')}
      onConfirm={handleConfirm}
      filterByLocation="exclude"
    />
  );
};

export default AddCoworkerSider;
